module.exports = __webpack_public_path__ + "img/zoom-in.0312231e.svg";